/** leads/NightlyToggle.tsx — 야간 자동 스캔 토글 (셸 우측 상단, 벤처기업 탭에서 노출) */
import React, { useEffect, useState } from 'react';
import { scanSchedule, scanScheduleSet } from './api';
import type { ScanSchedule } from './types';
import { getCandidateFilters } from './filterBus';

export default function NightlyToggle({ onToast }: { onToast: (m: string, t?: string) => void }) {
  const [sched, setSched] = useState<ScanSchedule | null>(null);
  useEffect(() => { scanSchedule().then(setSched).catch(() => {}); }, []);

  const toggle = async () => {
    const next = !(sched && sched.enabled);
    const f = getCandidateFilters();
    const scopeLabel = (f.region || '전국') + (f.sigungu ? ' ' + f.sigungu : '');
    if (next && !window.confirm('매일 새벽 ' + (sched?.run_hour ?? 2) + '시에 「' + scopeLabel + '」 범위를 자동 스캔합니다.\n(벤처기업 탭의 현재 지역·시군구 필터가 범위로 저장됩니다)')) return;
    try {
      const r = await scanScheduleSet({ enabled: next, region: f.region, sigungu: f.sigungu, run_hour: sched?.run_hour ?? 2 });
      setSched(r);
      onToast(next ? '야간 자동 스캔 예약 — ' + scopeLabel + ' · 매일 ' + r.run_hour + '시' : '야간 자동 스캔 해제');
    } catch (e) { onToast((e as Error).message, 'error'); }
  };

  return (
    <button className={'ld-btn' + (sched?.enabled ? ' pri' : '')} onClick={toggle} style={{ padding: '6px 12px', fontSize: 12 }}
      title={sched?.enabled ? '범위: ' + (sched.region || '전국') + ' ' + (sched.sigungu || '') + ' · 매일 ' + sched.run_hour + '시 · 해제하려면 클릭' : '매일 새벽 자동 스캔 예약 (범위 = 벤처기업 탭 현재 필터)'}>
      {sched?.enabled ? '🌙 매일 ' + sched.run_hour + '시 자동 ON' : '🌙 야간 자동'}
    </button>
  );
}
